import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  legend: {
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '10px',
    borderRadius: '5px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.4)',
    fontSize: '12px',
    fontFamily: 'Arial, Helvetica, sans-serif'
  },
  legendDark: {
    backgroundColor: '#37474f',
    padding: '10px',
    borderRadius: '5px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.4)',
    fontSize: '12px',
    fontFamily: 'Arial, Helvetica, sans-serif'
  },
  legendTitle: {
    marginBottom: '5px',
    fontWeight: 'bold'
  },
  legendItem: {
    marginBottom: '5px',
    display: 'flex',
    alignItems: 'center'
  },
  colorBox: {
    width: '15px',
    height: '15px',
    marginRight: '5px',
    borderRadius: '3px',
    boxShadow: '0px 0px 4px lightgrey'
  },
  legendText: {
    whiteSpace: 'nowrap'
  }
}));

const RTFOPressureAnalysisMapLegend = ({ 
  darkMode, 
}) => {
  
  const map = useMap();
  const classes = useStyles();

  useEffect(() => {

    let grades = [];
    let colors = [];

    grades = [0, 1, 2, 3, 4];
    colors = ['purple', 'blue', 'red', 'orange', 'grey'];

    const legend = L.control({ position: "topright" });

    legend.onAdd = () => {
      const div = L.DomUtil.create("div", (darkMode ? classes.legendDark : classes.legend));

      const item = L.DomUtil.create("div", classes.legendTitle, div);
      const seismicText = L.DomUtil.create("span", classes.legendTitle, item);
      seismicText.innerHTML = 'Fiber Data Legend';

      grades?.forEach((grade, i) => {
        const item = L.DomUtil.create("div", classes.legendItem, div);
        const colorBox = L.DomUtil.create("div", classes.colorBox, item);
        colorBox.style.backgroundColor = colors[i];
        const text = L.DomUtil.create("span", classes.legendText, item);
        if (grade === 0) {
          text.innerHTML = 'Reactivation';
        } else if (grade === 1) {
          text.innerHTML = 'Approaching Frac';
        } else if (grade === 2) {
          text.innerHTML = 'Frac Hit';
        } else if (grade === 3) {
          text.innerHTML = 'ByPass';
        } else {
          text.innerHTML = 'Other';
        };
      });

      return div;
    };

    legend.addTo(map);

    return () => {
      legend.remove();
    };
  }, [classes.colorBox, classes.legend, classes.legendDark, classes.legendTitle, classes.legendItem, classes.legendText, classes.seismicLegendTitle, classes.seismicColorBox, darkMode, map, classes.seismicLayerColorBox, classes.seismicLegendItem]);

  return null;
};

export default RTFOPressureAnalysisMapLegend;